import { COOKIE_POLICY_ROUTE_ID } from 'root/src/shared/descriptions/routes/routeIds'

export default {
	[COOKIE_POLICY_ROUTE_ID]: {
		// The cookie policy is served by the redesign page (RedesignCookiePolicyPage) in place at this URL.
		// No legacy modules: the global <RenderModules /> would otherwise render the OLD design below the
		// redesign content. The redesign page owns its own content.
		url: '/cookie-policy',
		modules: [],
	},
}
